module.exports = __webpack_public_path__ + "img/og-screen-4.c7f146bc.png";